/**
 * 常量定义
 */

// 城市等级
export const CITY_LEVELS = {
  1: '一线城市',
  2: '二线城市',
  3: '三线城市',
  4: '四线城市',
  5: '五线城市',
};

export const CITY_LEVEL_OPTIONS = [
  { value: 1, label: '一线城市' },
  { value: 2, label: '二线城市' },
  { value: 3, label: '三线城市' },
  { value: 4, label: '四线城市' },
  { value: 5, label: '五线城市' },
];

// 预警状态
export const WARNING_STATUS = {
  normal: '正常',
  warning: '预警',
  danger: '危险',
};

export const WARNING_STATUS_COLORS = {
  normal: '#52c41a',
  warning: '#faad14',
  danger: '#f5222d',
};

export const WARNING_STATUS_OPTIONS = [
  { value: 'normal', label: '正常', color: '#52c41a' },
  { value: 'warning', label: '预警', color: '#faad14' },
  { value: 'danger', label: '危险', color: '#f5222d' },
];

// 表格分页配置
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

// 日期格式
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// 文件上传配置
export const UPLOAD_CONFIG = {
  maxSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],
};

// 导航菜单
export const MENU_ITEMS = [
  {
    key: 'dashboard',
    label: '数据概览',
    icon: 'DashboardOutlined',
    path: '/',
    roles: ['admin', 'user'], // 所有用户都可以访问
  },
  {
    key: 'import-new',
    label: '检查报告导入',
    icon: 'CloudUploadOutlined',
    path: '/import-new',
    roles: ['admin', 'user'], // 所有用户都可以访问
  },
  {
    key: 'reports-new',
    label: '检查报告管理',
    icon: 'AuditOutlined',
    path: '/reports-new',
    roles: ['admin', 'user'], // 所有用户都可以访问
  },
  {
    key: 'warnings',
    label: '预警统计',
    icon: 'AlertOutlined',
    path: '/warnings',
    roles: ['admin', 'user'], // 所有用户都可以访问
  },
  {
    key: 'training-management',
    label: '培训信息收集管理',
    icon: 'FileTextOutlined',
    roles: ['admin', 'user'], // 所有用户都可以访问，权限控制在组件内部
    children: [
      {
        key: 'training-info',
        label: '培训信息收集',
        path: '/training-info',
        roles: ['admin', 'user'],
      },
      {
        key: 'training-analysis',
        label: '数据分析',
        path: '/training-analysis',
        roles: ['admin', 'user'],
      },
    ],
  },
  {
    key: 'faculty-management',
    label: '师资库管理',
    icon: 'UserOutlined',
    roles: ['admin', 'user'], // 所有用户都可以访问
    children: [
      {
        key: 'faculty-list',
        label: '师资列表',
        path: '/faculty',
        roles: ['admin', 'user'],
      },
      {
        key: 'faculty-add',
        label: '新增师资',
        path: '/faculty/add',
        roles: ['admin', 'user'],
      },
      {
        key: 'faculty-analytics',
        label: '师资分析',
        path: '/faculty/analytics',
        roles: ['admin', 'user'],
      },
    ],
  },
  {
    key: 'management',
    label: '基础数据管理',
    icon: 'SettingOutlined',
    roles: ['admin'], // 仅管理员可以访问
    children: [
      {
        key: 'cities',
        label: '城市管理',
        path: '/management/cities',
        roles: ['admin'],
      },
      {
        key: 'businesses',
        label: '培训业务管理',
        path: '/management/businesses',
        roles: ['admin'],
      },
      {
        key: 'elements',
        label: '培训要素管理',
        path: '/management/elements',
        roles: ['admin'],
      },
      {
        key: 'standards',
        label: '培训标准管理',
        path: '/management/standards',
        roles: ['admin'],
      },
      {
        key: 'users',
        label: '用户管理',
        path: '/management/users',
        roles: ['admin'],
      },
    ],
  },
];

// 统计卡片颜色
export const STAT_CARD_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#13c2c2',
];

// 图表颜色
export const CHART_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#13c2c2',
  '#eb2f96',
  '#fa8c16',
];